<div class="flex flex-column gap-4 align-items-center">
  <svg
    class="loader"
    width="125"
    height="125"
    viewBox="0 0 384 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M384 106.667L277.333 0H42.6667C31.3508 0 20.4983 4.49523 12.4968 12.4968C4.49522 20.4983 0 31.3508 0 42.6667V469.333C0 480.649 4.49522 491.502 12.4968 499.503C20.4983 507.505 31.3508 512 42.6667 512H341.333C352.649 512 363.502 507.505 371.503 499.503C379.505 491.502 384 480.649 384 469.333V106.667Z"
      fill="url(#paint0_linear)"
    />
    <path
      opacity="0.1"
      d="M341.333 506.667H42.6667C31.3508 506.667 20.4983 502.171 12.4968 494.17C4.49522 486.168 0 475.316 0 464V469.333C0 480.649 4.49522 491.502 12.4968 499.503C20.4983 507.505 31.3508 512 42.6667 512H341.333C352.649 512 363.502 507.505 371.503 499.503C379.505 491.502 384 480.649 384 469.333V464C384 475.316 379.505 486.168 371.503 494.17C363.502 502.171 352.649 506.667 341.333 506.667Z"
      fill="url(#paint0_linear)"
    />
    <path
      d="M72.5344 452.266L59.7344 435.2L68.2677 428.8C71.8641 426.045 75.2709 423.052 78.465 419.84C69.9744 408.106 64.001 394.773 64.001 384C64.001 359.658 83.4144 341.333 96.001 341.333C108.374 341.333 128.001 350.016 128.001 373.333C128.001 386.922 118.572 404.48 106.817 419.669C111.169 423.722 115.137 426.432 117.441 426.666C119.788 425.002 126.273 411.818 129.388 405.482C135.788 392.554 139.99 384 149.334 384C160.278 384 163.67 395.349 168.001 409.706C169.281 413.973 171.372 420.992 173.228 425.194C181.057 419.904 200.833 402.496 216.534 387.072L224.129 379.584L239.084 394.773L231.489 402.261C185.046 448 174.23 448 170.668 448C157.42 448 152.662 432.789 147.756 416.49C140.31 431.594 131.756 448 117.334 448C109.91 448 101.036 443.114 92.6944 435.669C89.0579 439.331 85.1731 442.739 81.0677 445.866L72.5344 452.266ZM96.001 362.666C90.3264 364.48 85.3344 370.986 85.3344 384C85.3344 389.461 88.4277 396.309 92.7584 402.922C100.908 391.616 106.668 380.138 106.668 373.333C106.668 363.178 99.585 361.536 96.001 362.666Z"
      fill="var(--primary-100)"
    />
    <path
      d="M277.332 0V64C277.332 75.3159 281.827 86.1683 289.829 94.1699C297.83 102.171 308.683 106.667 319.999 106.667H383.999L277.332 0Z"
      fill="url(#paint1_linear)"
    />
    <path
      opacity="0.2"
      d="M277.333 0H42.6667C31.3508 0 20.4983 4.49523 12.4968 12.4968C4.49522 20.4983 0 31.3508 0 42.6667V48C0 36.6841 4.49522 25.8317 12.4968 17.8301C20.4983 9.82856 31.3508 5.33333 42.6667 5.33333H277.333V0Z"
      fill="var(--primary-100)"
    />
    <path
      opacity="0.05"
      d="M319.999 101.334C308.683 101.334 297.83 96.8384 289.829 88.8369C281.827 80.8353 277.332 69.9829 277.332 58.667V64.0003C277.332 75.3162 281.827 86.1687 289.829 94.1702C297.83 102.172 308.683 106.667 319.999 106.667H383.999L378.665 101.334H319.999Z"
      fill="var(--primary-900)"
    />
    <path
      d="M64 106.667H213.333V128H64V106.667ZM170.667 298.667H320V320H170.667V298.667ZM64 170.667H320V192H64V170.667ZM64 234.667H320V256H64V234.667Z"
      fill="var(--primary-100)"
    />
    <path
      d="M320 106.667C308.267 106.667 297.664 101.931 289.941 94.2725L384 188.31V106.667H320Z"
      fill="var(--primary-100)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="192"
        y1="0"
        x2="192"
        y2="512"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--primary-400)" />
        <stop offset="1" stop-color="var(--primary-800)" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="330.665"
        y1="0"
        x2="330.665"
        y2="106.667"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--primary-600)" />
        <stop offset="1" stop-color="var(--primary-800)" />
      </linearGradient>
    </defs>
  </svg>

  <section class="dots-container">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </section>

  <div class="text-center">
    <p class="m-0 font-medium text-sm">Please wait</p>
    <p class="m-0 text-color-secondary text-xs">This may take a while.</p>
  </div>
</div>
